import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { Provider } from 'react-redux'
import { appQueryClient } from './lib/queryClient'
import { store } from './redux/store'
import { WebSocketProvider } from './context/webSocket'
import App from './App'
import './global-fonts.css'
import './apollo-icons.css'

import reportWebVitals from './reportWebVitals'
import { WebSocketUserProvider } from './context/webSocketUser'
import { WebSocketCasinoProvider } from './context/webSocketCasino'
import { WhatsAppNumbersProvider } from './context/WhatsAppNumbersContext'
import { fixResizeObserverError } from './utils/resizeObserverFix'

// Initialize ResizeObserver error fix
fixResizeObserverError();
const rootElement = document.getElementById('root');

if (rootElement) {
  ReactDOM.render(
    <Suspense
      fallback={
        <div className='suspense-loading'>
          <img src="/imgs/playkaro/playkaro_loader.gif" alt="Loader" width={250} height={250} />
        </div>
      }
    >
      <QueryClientProvider client={appQueryClient}>
        <Provider store={store}>
          <WebSocketProvider>
            <WebSocketUserProvider>
              <WebSocketCasinoProvider>
                <WhatsAppNumbersProvider>
                  <App />
                </WhatsAppNumbersProvider>
              </WebSocketCasinoProvider>
            </WebSocketUserProvider>
          </WebSocketProvider>
        </Provider>
      </QueryClientProvider>
    </Suspense>,
    rootElement
  )

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals()
}